<template>
	<div class="box">
		<div class="box-header">
			<h2 class="box-title">Fermenter Setup</h2>
		</div>
		<div class="box-body">

			<div class="margin-20"></div>

			<form class="form-horizontal">
				<fieldset>
					<input-select
						:select2="true"
						:options="tankGroupOptions"
						name="tank_group_id"
						:vmodel.sync="fermenter.tank_group_id"
						label="Tank Group">
					</input-select>

					<input-text name="name" label="Tank Name" :vmodel.sync="fermenter.name"></input-text>

					<input-text :textarea="true" name="description" label="Tank Description" :vmodel.sync="fermenter.description"></input-text>

					<input-text type="text" name="volume" label="Tank Volume" :vmodel.sync="fermenter.volume" :spinner="true" postfix="kL"></input-text>
				</fieldset>

				<fieldset>
					<legend>Properties (Optional)</legend>

					<input-select
						:options="[{ name: 'None', value: 1 }, { name: 'Full', value: 2 }, { name: 'Jacket Only', value: 3 }]"
						name="insulation"
						:vmodel.sync="fermenter.insulation"
						label="Insulation">
					</input-select>

					<div class="margin-20"></div>

					<input-text type="text" name="diameter" label="Diameter" :vmodel.sync="fermenter.diameter" :spinner="true" postfix="m"></input-text>

					<input-text type="text" name="height" label="Height" :vmodel.sync="fermenter.height" :spinner="true" postfix="m"></input-text>

					<input-text type="text" name="hd_ratio" label="H/D Ratio" :vmodel.sync="fermenter.hd_ratio" :spinner="true" postfix="m/m"></input-text>
				</fieldset>
			</form>

			<div v-if="fermenter.id">
				<a @click="destroy()" class="btn btn-danger"><i class="fa fa-close"></i> Delete Fermenter</a>
			</div>
		</div>
	</div>
</template>

<script>
	import { fermenter as activeFermenter, tankGroups, site } from 'vx/getters'
	import { TankGroups as TankGroupActions, Fermenters as FermenterActions } from 'vx/actions'
	import Alert from 'utils/alert'
	import Notify from 'utils/notify'
	import { validate } from 'utils/validator'

	export default {
		props: ['fermenter', 'justRepositioned'],

		data() {
			return {
				validation: {
					rules: {
						tank_group_id: 'required',
						name: 'required|max:25',
						volume: 'required'
					},
					messages: {
						'required.tank_group_id': 'The tank group field is required.'
					}
				},
				saveTimeout: null
			};
		},

		vuex: {
			actions: {
				updateFermenter: FermenterActions.update,
				editFermenter: FermenterActions.edit,
				clearFermenter: FermenterActions.clear,
				storeFermenter: FermenterActions.store,
				destroyFermenter: FermenterActions.destroy,
				clearFermenter: FermenterActions.clear,
				allTankGroups: TankGroupActions.all
			},

			getters: {
				tankGroups,
				site
			}
		},

		computed: {
			tankGroupOptions() {
				return this.tankGroups.map(tankGroup => {
					return { name: tankGroup.name, value: tankGroup.id }
				});
			}
		},

		watch: {
			fermenter: {
				handler(newFermenter, oldFermenter) {
					if (! newFermenter.tank_group_id || ! newFermenter.name || ! newFermenter.volume || newFermenter.id != oldFermenter.id || this.justRepositioned) {
						this.justRepositioned = false;

						return;
					}

					clearTimeout(this.saveTimeout);

					this.saveTimeout = setTimeout(() => {
						if (newFermenter.id) {
							this.save();
						} else {
							this.create();
						}
					}, 1250);
				},
				deep: true
			}
		},

		ready() {},

		methods: {
			validate,

			save() {
				this.validate(this.fermenter, this.validation.rules, this.validation.messages).passes(() => {
					this.updateFermenter(this.site.id, this.fermenter).then(() => {
						this.allTankGroups(this.site.id, ['fermenters']);

						Notify.success('Fermenter updated.');
					});
				});
			},

			create() {
				this.validate(this.fermenter, this.validation.rules, this.validation.messages).passes(() => {
					this.storeFermenter(this.site.id, this.fermenter).then(() => {
						this.allTankGroups(this.site.id, ['fermenters']);

						Notify.success('New fermenter added.');
					});
				});
			},

			destroy() {
				if (this.fermenter.ferments && this.fermenter.ferments.data.length) {
					Alert.error({ text: 'Unable to delete fermenter with an active ferment or historic ferments.' });

					return;
				}

				let self = this;

				Alert.delete({
					showLoaderOnConfirm: true,
					preConfirm() {
						return self.destroyFermenter(self.fermenter.id, self.site.id);
					}
				}).then(() => {
					this.clearFermenter();

					this.allTankGroups(this.site.id, ['fermenters']);

					Alert.success({ text: 'Fermenter has been deleted.' }).then(() => {}, () => {});
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// fermenters-form.vue?de1552ac